import script from "./SidebarIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarIcon.vue?vue&type=script&setup=true&lang=ts"

export default script